import { Segmented, Tooltip } from "antd";
import ListIcon from "@/assets/icons/list.svg?react";
import CardsIcon from "@/assets/icons/cards_stack.svg?react";

type DisplayModeToggleProps = {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  testIdPrefix?: string;
};

export default function DisplayModeToggle({
  value,
  onChange,
  disabled = false,
  testIdPrefix = "display",
}: DisplayModeToggleProps) {
  const displayOptions = [
    {
      label: (
        <Tooltip title="Expanded card view." mouseEnterDelay={1}>
          <span data-testid={`${testIdPrefix}-card-view-option`}>
            <CardsIcon className="mt-1" />
          </span>
        </Tooltip>
      ),
      value: "expanded",
    },
    {
      label: (
        <Tooltip title="Compact list view." mouseEnterDelay={1}>
          <span data-testid={`${testIdPrefix}-compact-view-option`}>
            <ListIcon className="mt-1" />
          </span>
        </Tooltip>
      ),
      value: "compact",
    },
  ];

  return (
    <div data-testid={`${testIdPrefix}-layout-toggle`}>
      <Segmented
        className="text-sm rounded-sm"
        defaultValue="expanded"
        options={displayOptions}
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
    </div>
  );
}
